import React from "react";
import { Card } from "react-bootstrap";

import CreateAdminForm from "../../../components/createAdminForm";

const CreateAdmin: React.FC = () => {
	return (
		<>
			<Card className="mb-3">
				<Card.Header>
					<h5>Create Admin User</h5>
				</Card.Header>
				<Card.Body className="bg-light">
					<CreateAdminForm />
				</Card.Body>
			</Card>
		</>
	);
};

export default CreateAdmin;
